<template>
  <v-select
    label="Select"
    v-model="selected_status"
    :items="status"
    :class="['contact-v-select', statusClass]"
    variant=""
    no-details
  >
    <template v-slot:item="{ item, props }">
      <v-list-item
        @click="updateStats(item)"
        v-bind="props"
        :title="item.raw.title"
        :style="{
          color:
            item.raw.title === 'active'
              ? '#2E6B30'
              : item.raw.title === 'completed'
              ? '#0464bc'
              : item.raw.title === 'on_hold'
              ? '#c14a05'
              : item.raw.title === 'pending'
              ? '#666666'
              : item.raw.title === 'closed'
              ? '#d91313'
              : '',
          background:
            item.raw.title === 'active'
              ? '#E3F9EB'
              : item.raw.title === 'completed'
              ? '#f5fafe'
              : item.raw.title === 'on_hold'
              ? '#fefbf1'
              : item.raw.title === 'pending'
              ? '#E6E6E6'
              : item.raw.title === 'closed'
              ? '#fef3f2'
              : '',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '5px 0px',
        }"
      >
      </v-list-item>
    </template>
  </v-select>
</template>
<script>
import apiClient from "@/core/buildRequest";
import { useTasksStore } from "@/store/crm/useTasksStore";
import { useGeneralStore } from "@/store/General";

export default {
  name: "statusCol",
  props: ["item", "id"],
  data() {
    return {
      selected_status: "",
      general_store: useGeneralStore(),
      status: [ {title: "active", value: "active"},
 {title: "completed", value: "completed"}, {title: "on hold", value: "on_hold"}, {title: "pending", value: "pending"}, {title: "closed", value: "closed"}],
    };
  },
  mounted() {
    this.selected_status = this.item.status;
  },
  computed: {
    statusClass() {
      switch (this.selected_status) {
        case "active":
          return "contact-v-select-green";
        case "completed":
          return "contact-v-select-blue";
        case "on_hold":
          return "contact-v-select-orange";
        case "pending":
          return "contact-v-select-gray";
        case "closed":
          return "contact-v-select-red";
        default:
          return "";
      }
    },
  },
  methods: {
    async updateStats(item) {
      await apiClient
        .post(`/leads-managment/task-status/${this.id}`, {
          status: item.value,
        })
        .then((res) => {
          const task_store = useTasksStore();
          task_store?.updateStatus(this.id, item.value);
          this.general_store.showSnackbar(res.data.msg, res.data.key);
        });
    },
  },
};
</script>
